import { PopupDimensionsKey } from "@/mixins/popup-mixin";
import type { PopupOptions } from "@/types/popup";

export function usePopup() {
  function openPopup({ url, title, x, y, w, h }: PopupOptions): void {
    const newWindow = window.open(
      url,
      title,
      `
      scrollbars=yes,
      width=${w},
      height=${h},
      top=${y},
      left=${x}
      `,
    );

    if (newWindow?.focus) newWindow?.focus();
  }

  function popupHeight(): number {
    return Number(localStorage.getItem(PopupDimensionsKey.height)) || 400;
  }

  function popupWidth(): number {
    return Number(localStorage.getItem(PopupDimensionsKey.width)) || 600;
  }

  function popupX(): number {
    return Number(localStorage.getItem(PopupDimensionsKey.x)) || 100;
  }

  function popupY(): number {
    return Number(localStorage.getItem(PopupDimensionsKey.y)) || 100;
  }

  return {
    openPopup,
    popupHeight,
    popupWidth,
    popupX,
    popupY,
  };
}
